// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
/** constante que hace referencia al Dominio que sera utilizado en la aplicación */
export const BASE_URL = 'https://detourpanel.cundinamarca.gov.co/';
/** Cadena con la url del bucket de inmersion */
const BUCKET_URL = 'https://nyc3.digitaloceanspaces.com/detour-media/prod/media/';

/** Cadena con la url de la CDN de FDM */
const CDN_URL = 'https://detourcdn.gumlet.io/';

/** Cadena con la url del logueo de Google y Facebook */
const API_AUTH_PROVIDER = 'https://auth.cundinamarca.gov.co/';

/** llave constante que sera utilizada para las peticiones de tipo autenticación, toma como base a **BASE_URL** */
const API_AUTH = `${BASE_URL}`;
/** variable constante que servira como base para los **request** o **peticiones** que se hagan al backend de la aplicación */
const API_URL = `${BASE_URL}api/v1/`;

const EPAYCO_KEY_AGGREGATOR = '9d9ef0222d6cb97f58a4636762510ec7'; // Grupotecnológico agregador
const EPAYCO_KEY_GATEWAY = '19cb7c4fcc9cb9f081f0d5c2e1380c5a'; // Grupotecnológico gateway
// export const EPAYCO_KEY = 'a41d42735935965264a440ede96c5523'; // Carlos

const FACEBOOK_APP_ID = '1351328626725184';

export const environment = {
  production: false,
  serverUrl: '/api',
  mapboxKey:
    'pk.eyJ1IjoibHVjaG91dG4iLCJhIjoiY2p3NXp3dWphMTR6ZTQ5bDl2c21vZHJ2NiJ9.d4rerbuQPjwx7JCKmKTDvg',
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US', 'es-ES'],
  TOKEN_KEY: 'Token', // Token name for every request with authorization
  TOKEN_STORAGE_KEY: 'auth', // name of localStorage or sessionStorage key data,
  bucketUrl: BUCKET_URL,
  cdnUrl: CDN_URL,
  apiAuth: API_AUTH,
  apiUrl: API_URL,
  apiAuthProvider: API_AUTH_PROVIDER,
  epaycoKeyAggregator: EPAYCO_KEY_AGGREGATOR,
  epaycoKeyGateway: EPAYCO_KEY_GATEWAY,
  facebookAppId: FACEBOOK_APP_ID,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
